/**
 * 工单质量审核
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 查询工单质量审核列表（分页）
    async fetchGetWorkOrderAuditPage({ commit, getters }, params) {
      const { getWorkOrderAuditPage } = getters.getHttps
      const { data } = await getWorkOrderAuditPage(params)
      return setStoreApiDate(data, commit)
    },
    // 获取工单详情
    async fetchGetWorkOrderDetail({ commit, getters }, params) {
      const { getWorkOrderDetail } = getters.getHttps
      const { data } = await getWorkOrderDetail(params)
      return setStoreApiDate(data, commit)
    },
    // 提交审核
    async fetchSubmitWorkOrderAudit({ commit, getters }, params) {
      const { submitWorkOrderAudit } = getters.getHttps
      const { data } = await submitWorkOrderAudit(params)
      return setStoreApiDate(data, commit)
    }
  }
}
